import { field, readContract } from "../viem";
import config from "../../config/config";
import MafiaOCLobbyAbi from "../../abis/MafiaOCLobby.json";

const address = config.ocLobbyAddress;
const abi = MafiaOCLobbyAbi;

export const getNextLobbyTime = async (account: string) => {
  const nextLobbyTime = await readContract<string>({
    address,
    abi,
    functionName: "nextLobbyTime",
    args: [account],
  });
  return Number(nextLobbyTime);
};

export const getIsInLobby = async (account: string) => {
  const isInLobby = await readContract({
    address,
    abi,
    functionName: "isInLobby",
    args: [account],
  });
  return Boolean(isInLobby);
};

export const getWasInLobby = async (lobbyId: number, account: string) => {
  const wasInLobby = await readContract({
    address,
    abi,
    functionName: "wasInLobby",
    args: [account, lobbyId],
  });
  return Boolean(wasInLobby);
};

export const getLobbyDetail = async (lobbyId: number) => {
  const lobby: any = await readContract({
    address,
    abi,
    functionName: "getLobby",
    args: [lobbyId],
  });

  return {
    currentRewardIndex: Number(field(lobby, "currentRewardIndex", 13)),
    isRewardClaimed: Boolean(field(lobby, "isRewardClaimed", 12)),
    rewards: field(lobby, "rewards", 14) || lobby.rewards || [],
  };
};
